<template>
    <div>
        <van-nav-bar :title="schoolInfo.name" left-text="返回" left-arrow @click-left="onClickLeft" />
        <div class="banner" @click="goSchoolVr(schoolInfo)">
            <div v-for="(item,index) in schoolInfo.xiangqing" :key="index">
                <img :src="item" />
            </div>
            <!-- <img v-else :src="schoolInfo.thumb"> -->
            <div class="tips">点击查看全景</div>
        </div>
        <div class="menu-list">
            <div class="menu" v-for="(i,index) in menu" :key="index">
                <p
                    :class="currentId === i.id?'menu-item-on':'menu-item'"
                    @click="chooseMenu(i)"
                >{{i.name}}</p>
            </div>
        </div>
        <!-- 院校信息 -->
        <div class="content">
            <div class="school-info" v-if="currentId === 1">
                <div class="school-name">{{schoolInfo.name}}</div>
                <div class="school-type">{{schoolInfo.label_str}}</div>
                <hr />
                <div class="school-address">
                    <div class="info-left">
                        <p>学校类型:{{schoolInfo.institution_str}}</p>
                        <p>批次:{{schoolInfo.disciplinary_level}}</p>
                    </div>
                    <div class="info-right">
                        <p>所在地:{{schoolInfo.province}}{{schoolInfo.city}}</p>
                        <p>其他:{{schoolInfo.school_nature}}</p>
                    </div>
                </div>
                <div :class="celled?'color':'share'" @click="shoucang(schoolInfo)">
                    <van-icon name="like" />
                </div>
                <div class="intro">
                    <h3>院校简介</h3>
                    <p v-html="content"></p>
                </div>
            </div>
            <!-- 招生简章 -->
            <div class="school-info" v-if="currentId === 2">
                <div class="school-name">招生简章</div>
                <div class="admissions-list" v-for="item in jianzhangList" :key="item.id">
                    <van-icon class="icon" name="arrow-down" />
                    <span @click="showMoreAdmissions(item)">{{item.title}}</span>
                    <div :class="jianzhangShow===item.id?'on':'off'">
                        <p v-html="item.content"></p>
                    </div>
                </div>
            </div>
            <!-- 开设专业 -->
            <div class="school-info" v-if="currentId === 3">
                <div class="school-name">开设专业</div>
                <div class="admissions-list" v-for="item in scholarships" :key="item.id">
                    <van-icon class="icon" name="arrow-down" />
                    <span @click="showMoreMajor(item)">{{item.extra_name}}</span>
                    <div :class="majorShow===item.id?'on':'off'">
                        <h5>专业概述</h5>
                        <p>{{item.gaishu}}</p>
                        <h5>开设课程</h5>
                        <p>{{item.courses}}</p>
                        <h5>培养目标</h5>
                        <p>{{item.mubiao}}</p>
                        <h5>就业方向</h5>
                        <p>{{item.sem}}</p>
                    </div>
                </div>
            </div>
            <!-- 历年分数 -->
            <!-- <div class="school-info" v-if="currentId === 4">
                <div class="school-name">历年分数</div>

                <Table class="small-table" size="small" border :columns="vipProductColumns" :data="data3"
                       :disabled-hover="true"></Table>
            </div>-->
            <!-- 奖学金 -->
            <div class="school-info" v-if="currentId === 5">
                <p class="intro" v-html="content1"></p>
            </div>
        </div>
    </div>
</template>

<script>
// import {httpPostRequest} from "../../axios/post";
import { httpPost } from "../../axios/index";
import share from "../../util/share.js";
export default {
    data() {
        return {
            currentId: 1,
            celled: false,
            menu: [
                {
                    id: 1,
                    name: "院校信息"
                },
                {
                    id: 2,
                    name: "招生简章"
                },
                {
                    id: 3,
                    name: "开设专业"
                },
                {
                    id: 4,
                    name: "历届分数"
                },
                {
                    id: 5,
                    name: "奖助学金"
                }
            ],
            schoolInfo: { xiangqing_arr: [] },
            jianzhangList: [], //招生简章
            majorList: [],
            scholarships: "", //奖学金
            jianzhangShow: 0,
            majorShow: 0,
            content: "",
            content1: ""
        };
    },
    created() {},
    methods: {
        // 点击收藏
        shoucang(e) {
            httpPost("/usercell/school_cell", {
                uid: this.$store.state.userInfo.user_id,
                school_id: e.id
            }).then(res => {
                if (res.msg == "收藏成功") {
                    this.celled = true;
                    this.$toast.success(res.msg);
                } else {
                    this.celled = false;
                    this.$toast.success(res.msg);
                }
                if (res.code === 0) {
                    this.$toast.success("您还未登录");
                }
            });
        },
        //校园全景
        goSchoolVr(schoolInfo) {
            this.$store.state.schoolid = schoolInfo.id;
            this.$store.state.linkurl = schoolInfo.linkurl;
            this.$router.push("/schoolVr");
        },
        //返回
        onClickLeft() {
            this.$router.go(-1);
        },
        chooseMenu(item) {
            if (item.id == 4) {
                this.$router.push({
                    path: "/pages/tabBar/school/scores/scores",
                    query: {
                        id: this.$route.query.id
                    }
                });
            }
            if (item.id === 3) {
                httpPost("/School/details_one", {
                    id: this.$store.state.schoolId,
                    user_id: this.$store.state.userInfo.user_id
                }).then(response => {
                    if (response.code === 1) {
                        this.schoolInfo = response.info;
                        this.content = response.data.description;
                        this.content1 = response.data.scholarships;
                    }
                });
                httpPost("/School/details_two", {
                    id: this.$store.state.schoolId,
                    user_id: this.$store.state.userInfo.user_id
                }).then(response => {
                    if (response.code === 1) {
                        this.jianzhangList = response.enrollment;
                        this.scholarships = response.career_list;
                    }
                });
            }
            this.currentId = item.id;
        },
        showMoreAdmissions(item) {
            if (this.jianzhangShow === item.id) {
                this.jianzhangShow = 0;
            } else {
                this.jianzhangShow = item.id;
            }
        },
        showMoreMajor(item) {
            if (this.majorShow === item.id) {
                this.majorShow = 0;
            } else {
                this.majorShow = item.id;
            }
        },
        load() {
            httpPost("/School/details_one", {
                id: this.$route.query.id,
                user_id: this.$store.state.userInfo.user_id
            }).then(response => {
                if (response.code === 1) {
                    this.schoolInfo = response.info;
                    this.content = response.data.description;
                    share(response.info);
                }
            });
            httpPost("/School/details_two", {
                id: this.$route.query.id,
                user_id: this.$store.state.userInfo.user_id
            }).then(response => {
                if (response.code === 1) {
                    this.jianzhangList = response.enrollment;
                    this.scholarships = response.career_list;
                }
            });
        }
    },
    mounted() {
        this.load();
    }
};
</script>

<style scoped>
.small-table .ivu-table-cell {
    padding: 0px;
}

.small-table td {
    height: 0px;
}

.banner {
    width: 100vw;
    position: relative;
}

.tips {
    position: absolute;
    bottom: 1rem;
    left: 1rem;
    color: #fff;
    z-index: 9;
    font-size: 0.5rem;
    padding: 0.05rem 0.2rem;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 0.5rem;
}

.banner img {
    width: 100%;
    height: 18.75rem;
}

.menu-list {
    display: flex;
    overflow-y: hidden;
    overflow-x: scroll;
    background: #25d1b1;
    padding: 1rem;
    color: #fff;
    font-size: 0.9rem;
    margin-top: -0.5rem;
}

.menu-item,
.menu-item-on {
    width: 7rem;
    text-align: center;
    line-height: 2rem;
    padding: 0.1rem;
}

.menu-item-on {
    border: 1px #fff solid;
    border-radius: 1.2rem;
}

.content {
    padding-bottom: 5rem;
}

.school-info {
    padding: 1rem;
    position: relative;
}

.share {
    position: absolute;
    font-size: 1.6rem;
    top: 1.5rem;
    right: 1.5rem;
}
.color {
    position: absolute;
    font-size: 1.6rem;
    top: 1.5rem;
    right: 1.5rem;
    color: rgb(164, 175, 14);
}
.share span {
    text-align: center;
    background: #bcbcbc;
    padding: 0.5rem 1rem 0 1rem;
    color: #fff;
    border-radius: 0.5rem;
}

.school-name {
    font-size: 1.5rem;
    padding-bottom: 0.5rem;
}

.school-type {
    padding-bottom: 0.75rem;
}

.school-address {
    display: flex;
    justify-content: space-between;
}

.info-left,
.info-right {
    padding: 1.5rem 0;
}

.icon {
    border: 1px red solid;
    border-radius: 50%;
    padding: 0.1rem;
    font-size: 0.1rem;
    margin-right: 0.5rem;
}

.admissions-list {
    line-height: 2.5rem;
    font-size: 1rem;
}

.off {
    display: none;
}

.on {
    display: block;
    font-size: 0.8rem;
}
.intro {
    font-size: 0.8rem;
}
.intro h3 {
    font-size: 1rem;
}
</style>
